import { useMemo } from "react";

const GRID_SIZE = 13;

// 150x150 dot-wave loader shown while an image is generating (before the
// ComfyUI decode preview frame arrives). Dots are positioned in a fixed grid;
// a brightness wave travels diagonally across them via per-dot negative
// animation-delay (phase = distance from the moving wave origin).
export function ImageLoader({ label }: { label?: string }) {
  const dots = useMemo(
    () =>
      Array.from({ length: GRID_SIZE * GRID_SIZE }, (_, i) => {
        const x = i % GRID_SIZE;
        const y = Math.floor(i / GRID_SIZE);
        // Diagonal wave phase + small organic variation.
        const wavePosition = x * 0.72 + y * 0.95;
        const variation = Math.sin(x * 2.31 + y * 1.73) * 0.025;
        return { x, y, delay: -(wavePosition * 0.085 + variation) };
      }),
    []
  );

  return (
    <div className="image-loader" role="img" aria-label={label ?? "Generating"}>
      <div className="image-loader-grid">
        {dots.map((d, i) => (
          <span key={i} className="image-loader-dot" style={{ ["--delay" as string]: `${d.delay}s` }} />
        ))}
      </div>
      {label && <div className="image-loader-label">{label}</div>}
    </div>
  );
}
